import React from 'react';

const FinalScore = ({totalQuestions, correctAnswers}) => {

    const size = 280;
    const stroke = 25;
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const percentage = totalQuestions === 0 ? 0 : Math.round((correctAnswers / totalQuestions) * 100);
    const strokeDashoffset = circumference - (percentage / 100) * circumference;


    return (
        <div className='final-score'>
            <h3 className='mb-8'>You scored {correctAnswers} out of {totalQuestions}</h3>
            <p className='mb-32'>Every quiz is progress — keep going!</p>
            <div className="score-box">
                <svg width={size} height={size}>
                    <circle
                        stroke="#E6E6E6"
                        fill="transparent"
                        strokeWidth={stroke}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                    />
                    <circle
                        stroke="#039855"
                        fill="transparent"
                        strokeWidth={stroke}
                        strokeLinecap="round"
                        strokeDasharray={`${circumference} ${circumference}`}
                        strokeDashoffset={strokeDashoffset}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                </svg>
                <div className="chartText">
                    <span>{percentage}%</span>
                    correct
                </div>
            </div>
        </div>
    );
}

export default FinalScore;